import Sketch from "./module"
import gsap from 'gsap'

let sketch = new Sketch({
    dom: document.getElementById("portContainer")
})

let attractMode =false
let attractTo = 0
let speed =0
let position =0
let rounded =0

// let block = document.getElementById('block')
let wrap = document.getElementById('wrap')
let elems = [...document.querySelectorAll('.n')]
let block = document.querySelector('#block')
let blockh1 = document.querySelector('#block h1')
let blockh2 = document.querySelector('#block h2')
let namespan = document.querySelectorAll('.namespan')
let lihover = document.querySelectorAll('.nav li')
let allimgs = document.querySelectorAll('.portContainer img')

window.addEventListener('wheel',(e)=>{
    speed += e.deltaY*0.0004
})

// allimgs.forEach(el=>{
//     console.log(el)
// })

// console.log(allimgs)
function changeBackground(e){
    
    if(sketch.meshes[0].position.y <=.59 ){
        block.style.backgroundColor = "#28b292"
        blockh1.textContent ="Production"
        blockh2.innerHTML ="I AM BACK END WEB DEVELOPER </br> I LOVE❤️ TO CODE IN PHP"
        blockh1.style.color="black"
        blockh2.style.color="black"
        elems[0].style.zIndex = 1000
        elems[1].style.zIndex = 999
        elems[2].style.zIndex = 999
        elems[3].style.zIndex = 999
        namespan.forEach(el=>{
            el.style.color ="#28b292"
        })
        lihover.forEach((el,val)=>{
            if(val === 0){
                    el.style.backgroundColor="black"
                }
            if(val === 1){
                el.style.backgroundColor="#eeeeee"
            }
            if(val === 2){
                el.style.backgroundColor="#eeeeee"
            }
            if(val === 3){
                el.style.backgroundColor="#eeeeee"
            }
        })
    }
    if(sketch.meshes[1].position.y <= .59 ){
        block.style.backgroundColor = "red"
        blockh1.textContent ="Media"
        blockh2.innerHTML ="I AM FRONT END WEB DEVELOPER </br> I LOVE❤️ TO CODE IN JAVASCRIPT"
        blockh1.style.color="#B9966E"
        blockh2.style.color="#B9966E"
        elems[0].style.zIndex = 999
        elems[1].style.zIndex = 1000
        elems[2].style.zIndex = 999
        elems[3].style.zIndex = 999
        namespan.forEach(el=>{
            el.style.color ="#153136"
        })
        lihover.forEach((el,val)=>{
            if(val === 0){
                el.style.backgroundColor="#eeeeee"
            }
            if(val === 1){
                el.style.backgroundColor="#B9966E"
            }
            if(val === 2){
                el.style.backgroundColor="#eeeeee"
            }
            if(val === 3){
                el.style.backgroundColor="#eeeeee"
            }
        })
    }
    if(sketch.meshes[2].position.y <=.59){
        block.style.backgroundColor = "#70CBCC"
        blockh1.textContent ="Advert"
        blockh2.innerHTML ="I AM PRODUCT MANAGER </br> I LOVE❤️ TO FIND CONTENT ONLINE"
        blockh1.style.color="black"
        blockh2.style.color="black"
        elems[0].style.zIndex = 999
        elems[1].style.zIndex = 999
        elems[2].style.zIndex = 1000
        elems[3].style.zIndex = 999
        namespan.forEach(el=>{
            el.style.color ="#70CBCC"
        })
        lihover.forEach((el,val)=>{
            if(val === 0){
                el.style.backgroundColor="#eeeeee"
            }
            if(val === 1){
                el.style.backgroundColor="#eeeeee"
            }
            if(val === 2){
                el.style.backgroundColor="#702415"
            }
            if(val === 3){
                el.style.backgroundColor="#eeeeee"
            }
        })
    }
    if( sketch.meshes[3].position.y <=.59){
        block.style.backgroundColor = "#A5489E"
        blockh1.textContent ="Graphics"
        blockh2.innerHTML ="I AM VIDEO EDITOR </br> I LOVE❤️ TO USE PREMIER PRO <br> PEOPLE ALSO KNOW ME AS DADA"
        blockh1.style.color="black"
        blockh2.style.color="black"
        elems[0].style.zIndex = 999
        elems[1].style.zIndex = 999
        elems[2].style.zIndex = 999
        elems[3].style.zIndex = 1000
        namespan.forEach(el=>{
            el.style.color ="#A5489E"
        })
        lihover.forEach((el,val)=>{
            if(val === 0){
                el.style.backgroundColor="#eeeeee"
            }
            if(val === 1){
                el.style.backgroundColor="#eeeeee"
            }
            if(val === 2){
                el.style.backgroundColor="#eeeeee"
            }
            if(val === 3){
                el.style.backgroundColor="#915211"
            }
        })
    }
}


window.addEventListener('wheel', changeBackground)

let objs = Array(4).fill({dist:0})

function raf(){
    position+=speed
    speed *= 0.8
    objs.forEach((o,i)=>{
        o.dist= Math.min(Math.abs(position -i),1)
        o.dist = 1 - o.dist**2
        // console.log(o.dist)
        // elems[i].style.transform = `scale(${1 + 0.4*o.dist})`
        let scale = 1+ 0.1*o.dist;
        sketch.meshes[i].position.y = i*1.2 - position*1.2
        // console.log(sketch.meshes[i].position.y)
        sketch.meshes[i].scale.set(scale,scale,scale)
        sketch.meshes[i].material.uniforms.distanceFromCenter.value = o.dist
    })

    rounded = Math.round(position)

    let diff = (rounded- position)


    if(attractMode){
         position += -(position - attractTo)*0.02
         switch (attractTo){
            case 0:
                {
                    block.style.backgroundColor = "#28b292"
                    blockh1.textContent ="Production"
                    blockh2.innerHTML ="I AM BACK END WEB DEVELOPER </br> I LOVE❤️ TO CODE IN PHP"
                    blockh1.style.color="black"
                    blockh2.style.color="black"
                    lihover.forEach((el,val)=>{
                        if(val === 0){
                            el.addEventListener('mouseenter',()=>{
                                el.style.backgroundColor="black"
                                elems[0].style.zIndex = 1000
                            })
                            el.addEventListener('mouseleave',()=>{
                                el.style.backgroundColor="#eeeeee"
                                elems[0].style.zIndex = 999
                                })
                            }
                    })
                    
                    namespan.forEach(el=>{
                        el.style.color ="black"
                    })
                    break;
                }
            case 1:
                {
                    block.style.backgroundColor = "red"
                    blockh1.textContent ="Media"
                    blockh2.innerHTML ="I AM FRONT END WEB DEVELOPER </br> I LOVE❤️ TO CODE IN JAVASCRIPT"
                    blockh1.style.color="#B9966E"
                    blockh2.style.color="#B9966E"
                    lihover.forEach((el,val)=>{
                        if(val === 1){
                            el.addEventListener('mouseenter',()=>{
                                el.style.backgroundColor="#B9966E"
                                elems[1].style.zIndex = 1000
                            })
                            el.addEventListener('mouseleave',()=>{
                                el.style.backgroundColor="#eeeeee"
                                elems[1].style.zIndex = 999
                            })
                        }
                    })
                    namespan.forEach(el=>{
                        el.style.color ="black"
                    })
                    break;
                }
            case 2:
                {
                    block.style.backgroundColor = "#70CBCC"
                    blockh1.textContent ="Advert"
                    blockh2.innerHTML ="I AM PRODUCT MANAGER </br> I LOVE❤️ TO FIND CONTENT ONLINE"
                    blockh1.style.color="black"
                    blockh2.style.color="black"
                    lihover.forEach((el,val)=>{
                        if(val === 2){
                            el.addEventListener('mouseenter',()=>{
                                el.style.backgroundColor="red"
                                elems[2].style.zIndex = 1000
                            })
                            el.addEventListener('mouseleave',()=>{
                                el.style.backgroundColor="#eeeeee"
                                elems[2].style.zIndex = 999
                            })
                        }
                    })
                    namespan.forEach(el=>{
                        el.style.color ="black"
                    })
                    break;
                }
            case 3:
                {
                    block.style.backgroundColor = "#A5489E"
                    blockh1.textContent ="Graphics"
                    blockh2.innerHTML ="I AM VIDEO EDITOR </br> I LOVE❤️ TO USE PREMIER PRO <br> PEOPLE ALSO KNOW ME AS DADA"
                    blockh1.style.color="black"
                    blockh2.style.color="black"
                    lihover.forEach((el,val)=>{
                        if(val === 3){
                            el.addEventListener('mouseenter',()=>{
                                el.style.backgroundColor="green"
                                elems[3].style.zIndex = 1000
                            })
                            el.addEventListener('mouseleave',()=>{
                                el.style.backgroundColor="#eeeeee"
                                elems[3].style.zIndex = 999
                            })
                        }
                    })
                    namespan.forEach(el=>{
                        el.style.color ="black"
                    })
                    break;
                }
         }
        //  ulhover.addEventListener('mouseenter',()=>{
        //     lihover.forEach((el,val)=>{
        //         if(val === 0){
        //             el.style.width = "10rem"
        //         }
        //         if(val === 1){
        //             el.style.width = "10rem"
        //         }
        //         if(val === 2){
        //             el.style.width = "10rem"
        //         }
        //         if(val === 3){
        //             el.style.width = "10rem"
        //         }
        //         if(val === 4){
        //             el.style.width = "10rem"
        //         }
        //     })
        //  })
    }else{
        position+=Math.sign(diff)*Math.pow(Math.abs(diff),0.7)*0.035

        // block.style.transform = `translate(0, ${position*100 +50}px)`
        // wrap.style.transform = `translate(0, ${position*100 +50}px)`
        // wrap.style.transform = `translate(0, ${position}px)`
        // sketch.meshes.forEach((mesh,i)=>{
        //     mesh.position.y = i*1.2 + position*1.2
        // })
    }

 
    window.requestAnimationFrame(raf)
}

raf()



let navs = [...document.querySelectorAll('li')]
let nav = document.querySelector('.nav')

let rots = sketch.groups.map(e=>e.rotation)
nav.addEventListener('mouseenter', ()=>{
    attractMode = true
    gsap.to(rots,{
        duration:0.3,
        x:-0.5,
        y:0,
        z:0
    })
})

nav.addEventListener('mouseleave', ()=>{
    attractMode = false
    gsap.to(rots,{
        duration:0.3,
        x:-0.3,
        y:-0.5,
        z:-0.3
    })
})

navs.forEach(el=>{
    
    el.addEventListener('mouseover',(e)=>{
        attractTo = Number(e.target.getAttribute('data-nav'))
    })
})